// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"211":"92084e6b","321":"ac1fd138","352":"092642ee","453":"20359781","557":"e022e805","566":"c91aa646","796":"c23f89c1"}[chunkId] + ".chunk.js";
};